import Vue from 'vue'
import { $appHook } from '@shared/model/$appHook'
import { deepMerge } from './deepMerge'
import { header } from '../components/header'

const defaultSelector = '.AxE-V-Component'
const AxE2BaseComponent = {
  data() {
    return {
      initialized: false,
    }
  },
  mounted() {
    setTimeout(async () => {
      this.initialized = true
      await $appHook.callHooks('AxE2.AxE2BaseComponent.mounted.AFTER')
    }, 10)
  },
}

const components = {
  header,
}

const snakeToCamel = (str) =>
  str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))

/**
 * HTMLに埋め込まれたVue的Componentを初期化する
 * 例: <div class="AxE-V-Component" data-component-name="universalComponent" :propName="something">
 * HTMLへアプリケーションをLoadするためのClass
 * 基本的には window.load() イベントにて発火
 */
export class AxE2Loader {
  targetElementSelector: string
  loadedVueInstances: Vue[]
  mainVueInstance: Vue
  constructor({ targetElementSelector }: { targetElementSelector?: string } = {}) {
    this.loadedVueInstances = []
    this.targetElementSelector = targetElementSelector || defaultSelector
  }
  load() {
    let $vueableElements = window.document.querySelectorAll(this.targetElementSelector)
    for (let i = 0; $vueableElements.length > i; i++) {
      const $elem = $vueableElements[i]
      this.loadToHtmlElement($elem)
    }
  }

  /**
   * Elementを利用して、vue化する
   * 外部JSからKickしてOK。
   * 例: WordPressから出されたHTMLをアプリケーションの部品化したい場合
   * @param $elem
   */
  loadToHtmlElement($elem: Element) {
    var componentName = null
    var attrs = $elem.attributes
    const props: { [propName: string]: any } = {}
    for (var i2 = 0, len = attrs.length; i2 < len; i2++) {
      if (attrs[i2].name.startsWith(':')) {
        const key = snakeToCamel(attrs[i2].name.replace(/^:/, '')) // <div class="AxE-V-Component" :propName="something"> を評価する
        try {
          eval(`props[key] = ` + attrs[i2].value)
        } catch (e) {
          props[key] = attrs[i2].value
        }
      } else if (attrs[i2].name == 'data-component-name') {
        componentName = attrs[i2].value
      }
    }
    const componentDefinition = componentName ? components[componentName] : AxE2BaseComponent
    const _data = deepMerge(componentDefinition.data() || {}, props)
    const data = () => {
      return _data
    }
    const vueInstance = new Vue({
      el: $elem,
      ...componentDefinition,
      data,
      template: `<${$elem.tagName} class="${$elem.className}" id="${$elem.id || ''}">${$elem.innerHTML}</${$elem.tagName}>`,
    })
    this.loadedVueInstances.push(vueInstance)
    // @ts-ignore
    if (!window.$AxE2VueInstance) {
      this.mainVueInstance = vueInstance
      // @ts-ignore
      window.$AxE2VueInstance = vueInstance
      window.$nuxt = vueInstance // CORE workaround
      window.$nuxt.$root = vueInstance // CORE workaround
    }
  }
}

export const $AxE2Loader = new AxE2Loader()
